module.exports = __webpack_public_path__ + "img/ckrw.9450227d.svg";